<div class="spacing">

        <mat-select [(value)]="selectedYear" class="width--25 small--font" placeholder="Filter by PGY"
        (selectionChange)="applyFilter(selectedYear)" disableRipple panelClass="mat-panel">
          <mat-option [value]="">Show All</mat-option>
          <mat-option [value]="1">1 </mat-option>
          <mat-option [value]="2">2 </mat-option>
          <mat-option [value]="3">3 </mat-option>
          <mat-option [value]="4">4 </mat-option>
          <mat-option [value]="5">5 </mat-option>
        </mat-select>

      <table class="mat-elevation-z8" matSort mat-table  matSortActive="residencyPostGraduateYear" matSortDirection="asc" [dataSource]="dataSource">
        <ng-container matColumnDef="residencyPostGraduateYear">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Year </th>
            <td mat-cell class="roster-table-top-padding" *matCellDef="let resident">
              <span [ngClass]="{'roster-table-number-one': resident.residencyPostGraduateYear ==='1', 
                'roster-table-number-two': resident.residencyPostGraduateYear ==='2', 
                'roster-table-number-three': resident.residencyPostGraduateYear ==='3',
                'roster-table-number-four': resident.residencyPostGraduateYear ==='4',
                'roster-table-number-five': resident.residencyPostGraduateYear ==='5'}"></span>
            </td>
          </ng-container>
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
          <td mat-cell *matCellDef="let resident"> {{resident.firstName}} </td>
        </ng-container>
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
          <td mat-cell *matCellDef="let resident"> {{resident.lastName}} </td>
        </ng-container>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer ID </th>
          <td mat-cell *matCellDef="let resident"> {{ trimLeadingZeros(resident.id) }} </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let resident"> {{resident.institutionalEmailAddress}} </td>
        </ng-container>
        <ng-container matColumnDef="residencyDates">
          <th mat-header-cell *matHeaderCellDef> Dates of Residency </th>
          <td mat-cell *matCellDef="let resident"> {{resident.residencyBeginDate | date: 'MMMM d, yyyy'}} to
            {{resident.residencyEndDate | date: 'MMMM d, yyyy'}}</td>
        </ng-container>
        <ng-container matColumnDef="npi">
          <th mat-header-cell *matHeaderCellDef> NPI </th>
          <td mat-cell *matCellDef="let resident"> {{resident.npi}} </td>
        </ng-container>
        <ng-container matColumnDef="registered">
            <th mat-header-cell *matHeaderCellDef> Registered </th>
            <td mat-cell *matCellDef="let resident">
                <mat-checkbox [checked]="resident.seatAssigned && resident.purchased" [disabled]="true">                    
                </mat-checkbox>
            </td>
          </ng-container>
   
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>    
      </table>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
